import React from 'react';
import { MdArrowBack as ArrowBack } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { AppBackground } from '../Components/Background';
// CSS
import './NotFoundLayout.css';

// #region COMPONENT
/**
 * @returns
 */
const NotFoundLayout = () => {
  // #regin INITIALIZATION
  // #endregion

  // #region INTERFACE
  return (
    <>
      <div className="NotFound-Container">
        <div className="NotFound-MainContainer">
          <div className="NotFound-TitleContainer">
            <h1 className="NotFound-title">404</h1>
          </div>
          <div className="NotFound-descriptionContainer">
            <p>
              Oups, it seems you have taken a wrong turn but don't worry, you
              can go back.
            </p>
          </div>
          <div className="NotFound-buttonContainer">
            <Link to="/">
              <ArrowBack className="AZmedNavbar-Icon" />
            </Link>
          </div>
        </div>
        <div className="NotFound-emptyContainer"></div>
      </div>
      <AppBackground />
    </>
  );
  // #endregion
};
// #endregion

export { NotFoundLayout };
